import { useState } from 'react'
import './LogoPack.scss'
export default function LogoPack() {
  const [value, setValue] = useState('deficandy')
  console.log(value);
  return (
    <div className="row justify-content-between">
      <div className="col-lg-4">
        <p>Downloadable gallery logo</p>
        <select className="form-select form-select-lg custom-input mb-3" value={value} onChange={(e) => setValue(e.target.value)}>
          <option selected disabled>Downloadable gallery logo</option>
          <option value="deficandy">Deficandy</option>
          <option value="speedswap">Speed Swap</option>
          <option value="followwhales">Follow Whale</option>
        </select>
      </div>
      <div className="col-lg-6">
        <div className="logoBox">
          <img src={`/images/logopack/${value}.png`} alt="deficandy" className="logoItem" />
          <a style={{ width: '100%' }} href={`/images/logopack/${value}.zip`} className="logoLink mt-3 myBtn orange light btn-block" download> Download </a>
        </div>
      </div>
    </div>
  )
}
